export default __webpack_public_path__ + "static/media/card-1.90108d28.jpeg";